/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workOrderActions from 'actions/workOrderActions';
//import Loading from 'components/layout/Loading';
import Footer from 'containers/Footer';
import TechHistory from 'techComponents/TechHistory';
import SearchIcon from 'material-ui/svg-icons/action/search';

export class TechHistoryPage extends React.Component {
    constructor(props, context) {
        super(props, context);

    }

    render() {

        const {
            userData,
            techData,
            workOrderActions
        } = this.props;

        return (
            <div>
                <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '1em', justifyContent: 'center' }}>
                    <SearchIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Tech Order History
                </h5>
                <TechHistory
                    techData={techData}
                    userData={userData}
                    workOrderActions={workOrderActions}
                />
                <Footer />
            </div>
        );
    }
}

TechHistoryPage.propTypes = {
    userData: PropTypes.object,
    techData: PropTypes.object,
    workOrderActions: PropTypes.object
};

function mapStateToProps(state) {
    return {
        userData: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        push: bindActionCreators(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TechHistoryPage);


// WEBPACK FOOTER //
// ./src/containers/pages/TechHistoryPage.js